import { html, render } from "lit-html";
import { connect } from "../connect-with-dialog";
import { translate } from "@escapio/shared/l10n/translate";
import { DirectContactDialog } from "./DirectContactDialog";

customElements.define(
	"esc-hotel-direct-contact-dialog-opener",
	connect(
		DirectContactDialog,
		class extends HTMLElement {
			connectedCallback() {
				render(
					html`<esc-impression-interaction-tracker
						content-name="Direktkontakt"
						content-piece="${this.hotelId} | ${this.hotelName}"
						content-target="#"
					>
						<a
							class="price-comparer__offer"
							href="#"
							@click=${e => e.preventDefault()}
						>
							<div class="offer__left-container">
								<div class="offer__provider-room-container">
									<div class="offer__provider-name">
										${translate("hotel_direct_contact_request_offer")}
									</div>
									<div class="offer__room ellipsis">${this.hotelName}</div>
								</div>
								<div class="offer__features offer__features--direct-link">
									${translate("hotel_direct_contact_features")}
								</div>
							</div>
							<div
								class="offer__right-container offer__right-container--direct-link"
							>
								<div>
									${translate("hotel_direct_contact_open_form")}<span
										class="fa fa-angle-right fa--space-before"
									></span>
								</div></div
						></a>
					</esc-impression-interaction-tracker>`,
					this,
				);
			}

			get hotelId() {
				return this.getAttribute("hotel-id");
			}

			get hotelName() {
				return this.getAttribute("hotel-name");
			}
		},
	),
);
